import Vue from 'vue'
import Router from 'vue-router'
import loginStorage from '../storage/login'
import store from '../store/index'
//
// Authentication Components
//
import login from '../components/Authentication/Login'
import home from '../components/Bases/Home'
//
//Main Components
//
import dashboard from '../components/Dashboards/Dashboard'
import categories from '../components/Categories/Categories'
import categoryaddform from '../components/Categories/CategoryAddForm'
import categoryeditform from '../components/Categories/CategoryEditForm'
import items from '../components/Items/Items'
import itemaddform from '../components/Items/ItemAddForm'
import itemeditform from '../components/Items/ItemEditForm'
import openingtimes from '../components/OpeningTimes/OpeningTimes'
import openingtimeeditform from '../components/OpeningTimes/OpeningTimeEditForm'
import menus from '../components/Menus/Menus'
import menuaddform from '../components/Menus/MenuAddForms/MenuAddForm'
import menueditform from '../components/Menus/MenuEditForms/MenuEditForm'
import itemssearch from '../components/Items/ItemsSearch'
import restauranteditform from '../components/Restaurants/RestaurantEditForm'
import orders from '../components/Orders/Orders'
import ordermessages from '../components/OrdersDashboard/OrderControl'
import orderbyphoneaddform from '../components/OrdersByPhone/OrderByPhoneAddForm'
import currentorders from '../components/OrdersDashboard/CurrentOrders'
import taxes from '../components/Taxes/Taxes'
import taxaddform from '../components/Taxes/TaxAddForm'
import printer from '../components/Settings/Printer'
import payment from '../components/Settings/Payment'
Vue.use(Router)

export default new Router({
  linkActiveClass: 'active',
  mode: 'history',
  routes: [{
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '/',
    name: 'home',
    component: home,
    meta: {requiresAuth: true},
    beforeEnter: (to, from, next) => {
      
      if(loginStorage.getToken() != null && loginStorage.getRestaurantOwnerId() != null) {
        store.dispatch('login/loadProfileFromStorageAction', {root: true});
        store.dispatch('restaurants/loadRestaurantsFromStorageAction', {root: true});
        next();
      }
      else {
        next({
          path: '/login',
          params: { nextUrl: to.fullPath }
        });
      }
    },
    children: [
      {
        path: '',
        component: dashboard
      }, 
      {
        path: 'categories',
        component: categories
      },
      {
        name: 'categoryaddform',
        path: 'addcategory',
        component: categoryaddform
      },
      {
        name: 'categoryeditform',
        path: 'editcategory/:id',
        component: categoryeditform
      },
      {
        name: 'items',
        path: 'items',
        component: items
      },
      {
        name: 'itemaddform',
        path: 'additem',
        component: itemaddform
      },
      {
        name: 'itemeditform',
        path: 'edititem/:id',
        component: itemeditform
      },
      {
        name: 'openingtimes',
        path: 'openingtimes',
        component: openingtimes
      },
      {
        name: 'openingtimeeditform',
        path: 'openingtimeeditform/:id',
        component: openingtimeeditform
      },
      {
        name: 'menus',
        path: 'menus',
        component: menus
      },
      {
        name: 'menuaddform',
        path: 'addmenu',
        component: menuaddform
      },
      {
        name: 'menueditform',
        path: 'editmenu/:id',
        component: menueditform
      },
      {
        name: 'itemssearch',
        path: 'itemssearch',
        component: itemssearch
      },
      {
        name: 'restauranteditform',
        path: 'restauranteditform',
        component: restauranteditform
      },
      {
        name: 'ordermessages',
        path: 'ordermessages',
        component: ordermessages
      },
      {
        name: 'orderbyphoneaddform',
        path: 'orderbyphoneaddform/:id',
        component: orderbyphoneaddform
      },
      {
        name: 'currentorders',
        path: 'currentorders',
        component: currentorders
      },
      {
        name: 'taxes',
        path: 'taxes',
        component: taxes
      },
      {
        name: 'taxaddform',
        path: 'addtax',
        component: taxaddform
      },
      {
        name: 'printer',
        path: 'printer',
        component: printer
      },
      {
        name: 'payment',
        path: 'payment',
        component: payment
      },
      {
        name: 'orders',
        path: 'orders',
        component: orders
      }
    ]
  }]
})